import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const PrivateRoute = () => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div>Loading...</div>; // Or a loading spinner
  }

  // Check if user exists AND is not an admin (admin users should use admin routes)
  // Regular users have userId, admin users have isAdmin
  const isRegularUser = user && user.userId && !user.isAdmin;

  if (!isRegularUser) {
    return <Navigate to="/register" />;
  }

  // Note: condition/instance selection is handled by ConditionInitializer
  // which sits above PrivateRoute in the component tree. If we reach here,
  // the session should already be initialized.

  return <Outlet />;
};

export default PrivateRoute;
